import { PayloadAction } from '@reduxjs/toolkit';
import { EditorState } from 'src/store/editor/types';

const setEditorBackgroundColorReducer = (state: EditorState, action: PayloadAction<string>) => {
  state.backgroundColor = action.payload;
};

export default setEditorBackgroundColorReducer;
